// this file cannot have any imports up here (other than types) //

export const isExcel: boolean = (window as any).windowExcelFlag === true;
